import request from '@/utils/request'

export function getByMobile(mobile){
    return request({
        url:'/member/user/get-by-mobile?mobile='+mobile,
        method:'get'
    })
}
